import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import {useSelector} from "react-redux";
import {getCurrencies} from "../../../Util/SiteDataUtil";
import TablePageContext from "../../../Context/TablePageContext";
import LinearProgress from '@mui/material/LinearProgress';
import { editOrganisationUserContract, getAllUsers } from "../../../Services/HR/OrganisationUserContractService";
import OrganisationUserContractForm from "../../../Components/Forms/Pages/HR/OrganisationUserContract/OrganisationUserContractForm";
import SnackbarContext from "../../../Context/SnackbarContext";

const formRules = {
    'name': {required: true},
    'gross': {required: true},
    'type': {required: true},
    'startDate': {required: true},
    'paymentDay': {min: 1, max: 31, required: true},
    'user': {required: true},
    'net': {required: true},
    'currency': {required: true},
    'paymentMonth': {required: true}
}

const EditOrganisationUserContract = (props) => {
    const siteData = useSelector((state) => state.siteData)
    const {setDrawerTitle} = useContext(DrawerContext);
    const {showMessage} = useContext(SnackbarContext);
    const form = useForm({
        defaultValues: props.data && props.data.length > 0 ? {...props.data[0],
            type:{id: props.data[0].type},
            paymentMonth:{value: props.data[0].paymentMonth},
            endDate:  props.data[0].endDate || NaN
        } : undefined
    });
    const {data, control, handleSubmit, getValues, setValue, trigger, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [users, setUsers] = useState(0);

    useEffect(() => {
        setDrawerTitle(strings.pages.hr.organisationUserContract.editOrganisationUserContract.pageTitle);
    });

    useEffect(() => {
        fetch();
    }, []);

    const fetch = () => {
        getAllUsers().then(response =>{
            if (!response || !response.ok){
                return;
            }
            setUsers(response.data);
        });
    }

    const onSubmit = (data) => {
        setShowLoader(true);

        editOrganisationUserContract(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok){
                showMessage(strings.commonMessages.errorEditing, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.editingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress />
            }
            <OrganisationUserContractForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                currencies={getCurrencies(siteData)}
                errors={errors} data={data} form={form}
                users={users} control={control} trigger={trigger}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()} />
        </Paper>
    </div>
}

export default EditOrganisationUserContract;